import appState from '../../state/AppStateContainer';
import Loading from '../../components/shared/Loading';
import SupplierCompanyCard, { useSupplierCompanyCardData } from '../page-sales-tool/supplier-company-card';

const AdApplicationDetailPanel = ({ rowData, history }) => {
  const requestingOrg = appState.getOrgFromUrl();
  const hasSyna = !!requestingOrg?.hasSyna;
  const hasCreditsafe = !!requestingOrg?.hasCreditsafe;
  const hasTic = !!requestingOrg?.hasTic;

  const { companyInfo, supplierStats, ratingInfo, kpiData, groupedUsers, reachData, loading } =
    useSupplierCompanyCardData(rowData.organizationNumber);

  return (
    <div className="sp-row-detail-wrapper-wrapper">
      <div className="sp-row-detail-wrapper">
        <div className="ar-row">
          <div className="ar-column detail-left-col" style={{ marginBottom: '20px', paddingTop: '32px' }}>
            {loading ? (
              <Loading type="inline" loadingStyle="bubbles" size="30px" />
            ) : (
              <SupplierCompanyCard
                companyInfo={companyInfo}
                supplierStats={supplierStats}
                ratingInfo={ratingInfo}
                kpiData={kpiData}
                groupedUsers={groupedUsers}
                reachData={reachData}
                fallbackCompanyName={rowData.companyName}
                fallbackOrganizationNumber={rowData.organizationNumber}
                history={history}
                hasSyna={hasSyna}
                hasCreditsafe={hasCreditsafe}
                hasTic={hasTic}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdApplicationDetailPanel;
